import React, { memo } from 'react';
import { MultivariateExperiment } from 'site-modules/shared/components/experiment/multivariate-experiment';
import { getDimensionsConfig } from 'site-modules/shared/components/incentives/incentives-wizard/utils/with-shop-3751-wiz-ax';

export function withShop3751Ax(WrappedComponent) {
  const Shop3751aXExperiment = memo(props => (
    <MultivariateExperiment
      name="shop-3751-wiz-ax"
      featureFlagId="shop-3751-wiz-ax-ff"
      defaultDimensions={{
        copy: 'default',
        cta: 'default',
        design: 'default',
      }}
    >
      {({ copy: copyShop3751, cta: ctaShop3751, design: designShop3751 }) => {
        const dimensionsConfig = getDimensionsConfig({ copyShop3751, ctaShop3751, designShop3751 });
        return <WrappedComponent {...props} shop3751AxConfig={dimensionsConfig} />;
      }}
    </MultivariateExperiment>
  ));

  Shop3751aXExperiment.displayName = `withShop3751aX(${WrappedComponent.name || WrappedComponent.displayName})`;

  return Shop3751aXExperiment;
}
